import Map from 'scripts/models/base/map';

export default Map.extend({
    define: {
        identifier: {
            type: 'integer',
            value: 0 // required
        },
        par: {
            type: 'integer',
            value: 0 // required
        }
    }
});